import CopyToClipboard from './copy-to-clipboard'

export type { CopyToClipboardProps } from './copy-to-clipboard'

export default CopyToClipboard
